import { render, staticRenderFns } from "./YoutubeBlock.vue?vue&type=template&id=281a42ee&scoped=true&"
import script from "./YoutubeBlock.vue?vue&type=script&lang=js&"
export * from "./YoutubeBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "281a42ee",
  null
  
)

export default component.exports